module.exports = __webpack_public_path__ + "static/img/jy.b15b8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/introduce/images/jy.png
// module id = Gtsx
// module chunks = 21